import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container text-center" }, [
  /*#__PURE__*/_createVNode("h1", null, "Iceberg"),
  /*#__PURE__*/_createVNode("p", { class: "lead" }, "The slogan that's still a work in progress"),
  /*#__PURE__*/_createVNode("p", { class: "mt-5" }, [
    /*#__PURE__*/_createTextVNode(" We're working on a design system to create a unified design and experience throughout the services that Tradesolution offers."),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" Our intention is to strengthen the collaboration between design and the development process by providing a common vocabulary. ")
  ])
], -1)
const _hoisted_3 = { class: "container mt-5 mb-5" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "widget" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Team = _resolveComponent("Team")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Team)
        ])
      ])
    ])
  ]))
}